import { useState, useEffect } from "react";
import "./QuestionSettingsContact.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { iconPath, Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
// import { FormCountryCodes } from "../form-widgets/FormCountryCodes";
import { CountrySelect, en } from "../form-widgets/CountrySelect";
import { MySwitch } from "../form-widgets/MySwitch";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";


type QuestionSettingsContactProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsContact = ({question, onChange} : QuestionSettingsContactProps) => {

    const storeUser = useSelector(selectUser)

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsContact/handleTypeChange] value: ", value);
    }

    const handleRequiredChange = async (checked: boolean) => {
        setRequired(checked);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required: checked,
            settings: JSON.stringify(settings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    const handleSettingChange = async (e: any) => {
        console.log("[QuestionSettingsContact/handleSettingChange] e: ", e);

        let newSettings = {...settings};

        switch (e.target.name) {
            default:
                newSettings = {...settings, [e.target.name]: e.target.value};
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }

    const handleSwitchSettings = async (name: string, checked: boolean) => {
        console.log("[QuestionSettingsContact/handleSwitchSettings] name: ", checked);

        let newSettings = {...settings};

        switch (name) {
            case "firstNameRequired":
                newSettings = {
                    ...settings, 
                    [name]: checked,
                };
                if (checked) {
                    newSettings = {...newSettings, firstNameVisible: true};
                }
                break;
            case "lastNameRequired":
                newSettings = {
                    ...settings, 
                    [name]: checked,
                };
                if (checked) {
                    newSettings = {...newSettings, lastNameVisible: true};
                }
                break;
            case "phoneRequired":
                newSettings = {
                    ...settings, 
                    [name]: checked,
                };
                if (checked) {
                    newSettings = {...newSettings, phoneVisible: true};
                }
                break;
            case "emailRequired":
                newSettings = {
                    ...settings, 
                    [name]: checked,
                };
                if (checked) {
                    newSettings = {...newSettings, emailVisible: true};
                }
                break;
            case "companyRequired":
                newSettings = {
                    ...settings, 
                    [name]: checked,
                };
                if (checked) {
                    newSettings = {...newSettings, companyVisible: true};
                }
                break;
            case "firstNameVisible":
            case "lastNameVisible":
            case "phoneVisible":
            case "emailVisible":
            case "companyVisible":
                newSettings = {...settings, [name]: checked};
                break;
            default:
                // nadad
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }


    const handleDefaultCountryCodeChange = async (value: string) => {
        const newSettings = {...settings, defaultCountryCode: value};

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    // console.log("[QuestionSettingsContact] settings: ", settings);

    return (        
        <>
            <div className="question-settings-contact">
                {/* <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div> */}

                {/* <div className="question-setting">
                    <div className="question-setting-label">
                        Required
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="required"
                            checked={required}
                            onChange={(checked: boolean) => 
                                handleRequiredChange(checked)
                            } 
                        />
                    </div>
                </div> */}

                <div className="question-setting">
                    <div className="question-setting-label">
                        { }
                    </div>
                    <div className="question-setting-bundle">

                        <div className="question-setting-icon">
                            <img src={iconPath("required.png", storeUser)} />
                        </div>
                        <div className="question-setting-icon">
                            <img src={iconPath("visible.png", storeUser)} />
                        </div>
                    </div>
                </div>

                <div className="question-setting">
                    <div className="question-setting-label">
                        First Name
                    </div>
                    <div className="question-setting-bundle">

                        <div className="question-setting-radio">
                            <MySwitch 
                                id="firstNameRequired"
                                checked={settings?.firstNameRequired}
                                onChange={(checked: boolean) => 
                                    handleSwitchSettings("firstNameRequired", checked)
                                }
                            />
                        </div>
                        <div className="question-setting-radio">
                            <MySwitch 
                                id="firstNameVisible"
                                checked={settings?.firstNameVisible}
                                onChange={(checked: boolean) => 
                                    handleSwitchSettings("firstNameVisible", checked)
                                }
                                disabled={settings?.firstNameRequired}                             
                            />
                        </div>
                    </div>
                </div>

                <div className="question-setting">
                    <div className="question-setting-label">
                        Last Name
                    </div>
                    <div className="question-setting-bundle">
                        <div className="question-setting-radio">
                            <MySwitch 
                                id="lastNameRequired"
                                checked={settings?.lastNameRequired}
                                onChange={(checked: boolean) => 
                                    handleSwitchSettings("lastNameRequired", checked)
                                } 
                            />
                        </div>
                        <div className="question-setting-radio">
                            <MySwitch 
                                id="lastNameVisible"
                                checked={settings?.lastNameVisible}
                                onChange={(checked: boolean) => 
                                    handleSwitchSettings("lastNameVisible", checked)
                                }   
                                disabled={settings?.lastNameRequired}                          
                            />
                        </div>
                    </div>
                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Email
                        </div>
                        <div className="question-setting-bundle">

                            <div className="question-setting-radio">
                                <MySwitch 
                                    id="emailRequired"
                                    checked={settings?.emailRequired}
                                    onChange={(checked: boolean) => 
                                        handleSwitchSettings("emailRequired", checked)
                                    }                            
                                />
                            </div>
                            <div className="question-setting-radio">
                                <MySwitch 
                                    id="emailVisible"
                                    checked={settings?.emailVisible}
                                    onChange={(checked: boolean) => 
                                        handleSwitchSettings("emailVisible", checked)
                                    } 
                                    disabled={settings?.emailRequired}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Phone
                        </div>
                        <div className="question-setting-bundle">

                            <div className="question-setting-radio">
                                <MySwitch 
                                    id="phoneRequired"
                                    checked={settings?.phoneRequired}
                                    onChange={(checked: boolean) => 
                                        handleSwitchSettings("phoneRequired", checked)
                                    }
                                />
                            </div>
                            <div className="question-setting-radio">
                                <MySwitch 
                                    id="phoneVisible"
                                    checked={settings?.phoneVisible}
                                    onChange={(checked: boolean) => 
                                        handleSwitchSettings("phoneVisible", checked)
                                    }
                                    disabled={settings?.phoneRequired}
                                />
                            </div>
                        </div>
                    </div>

                    {settings?.phoneVisible &&
                        <>
                            <span>Default Area Code: </span>
                            <div className="question-setting-stack-bottom">
                                
                                <CountrySelect
                                    labels={en}
                                    value={settings?.defaultCountryCode}
                                    onChange={handleDefaultCountryCodeChange}
                                    data-testid="defaultCountryCode"
                                />
                            </div>
                        </>
                    }
                </div>

                

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Company
                        </div>
                        <div className="question-setting-bundle">

                            <div className="question-setting-radio">
                                <MySwitch 
                                    id="companyRequired"
                                    checked={settings?.companyRequired}
                                    onChange={(checked: boolean) => 
                                        handleSwitchSettings("companyRequired", checked)
                                    }                             />
                            </div>
                            <div className="question-setting-radio">
                                <MySwitch 
                                    id="companyVisible"
                                    checked={settings?.companyVisible}
                                    onChange={(checked: boolean) => 
                                        handleSwitchSettings("companyVisible", checked)
                                    } 
                                    disabled={settings?.companyRequired}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
            
        </>
    )
}